import React from 'react';
import { Skeleton } from '@material-ui/lab';
import { AutocompleteArrayTextInput } from '~/components';
import { useGetAllProfileTags } from '~/hooks/profileTags';

interface ProfileTagsFilterInputProps {
  value: any;
  onChange: (event: any, value: any) => void;
  label: string;
  className?: string;
}

const ProfileTagsFilterInput: React.FC<ProfileTagsFilterInputProps> = ({
  value,
  onChange,
  label,
  className,
}) => {
  const { data: allTags, isLoading: allTagsLoading } = useGetAllProfileTags();
  const autocompleteOptions = allTags?.map((tag) => tag?.name);

  if (allTagsLoading) {
    return <Skeleton width='100%' />;
  }
  return (
    <AutocompleteArrayTextInput
      name='profileTags'
      source='profileTags'
      label={label}
      options={autocompleteOptions}
      onChange={onChange}
      value={value}
      className={className}
      freeSolo={false}
      disableHelperText
    />
  );
};

export default ProfileTagsFilterInput;
